import React from 'react';
import { Card, Button, Form, Col, Tabs, Tab, ButtonToolbar, Dropdown, ToggleButton, ButtonGroup } from 'react-bootstrap';
import FormControls from '../../../controls/formControls';

const CustomerCodingProfile = (props) => {
    const validationTools = [{ id: 1, name: "SHP" }, { id: 2, name: "Validate" }, { id: 3, name: "OASIS Check/Analysis" }];
    const verificationModes = [{ id: 1, name: "Code and client will verify with MD prior to pock." }, { id: 2, name: "Every chart on hold until verified." }];
    const reviewReturnMethods = [{ id: 1, name: "In software comments" }, { id: 2, name: "Email" }, { id: 3, name: "Upload" }];

    const formHandler = props.formHandler;

    const getContactInfo = (id) => {
        var result = props.contacts.filter(obj => {
            return obj.id === id;
        });
        if (result.length > 0) {
            return (
                <> {result[0].fullName} <br /> {result[0].emailAddress} <br /> {result[0].phoneNumber}</>
            );
        }
        return <> Undefined contact<br />&nbsp;<br />&nbsp;</>;
    }

    return (
        <>
            <Form.Row>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.ButtonGrouping
                        label="Code in software?"
                        name="codeInSoftware"
                        variant="secondary"
                        size="sm"
                        formHandler={formHandler}
                        options={[{ value: true, name: "Yes" }, { value: false, name: "No" }]} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.ButtonGrouping
                        label="Change visit status/location?"
                        name="changeVisitStatusLocation"
                        variant="secondary"
                        size="sm"
                        formHandler={formHandler}
                        options={[{ value: true, name: "Yes" }, { value: false, name: "No" }]} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.ButtonGrouping
                        label="Change 485 status/location?"
                        name="change485StatusLocation"
                        variant="secondary"
                        size="sm"
                        formHandler={formHandler}
                        options={[{ value: true, name: "Yes" }, { value: false, name: "No" }]} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.ButtonGrouping
                        label="Enter note stating review complete?"
                        name="enterNoteStatingReviewComplete"
                        variant="secondary"
                        size="sm"
                        formHandler={formHandler}
                        options={[{ value: true, name: "Yes" }, { value: false, name: "No" }]} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.ButtonGrouping
                        label="Use our worksheets?"
                        name="useOurWorksheets"
                        variant="secondary"
                        size="sm"
                        formHandler={formHandler}
                        options={[{ value: true, name: "Yes" }, { value: false, name: "No" }]} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.ButtonGrouping
                        label="Enter severity codes?"
                        name="enterSeverityCodes"
                        variant="secondary"
                        size="sm"
                        formHandler={formHandler}
                        options={[{ value: true, name: "Yes" }, { value: false, name: "No" }]} />
                </Form.Group>
                <FormControls.ConditionalRender visible={formHandler.values.enterSeverityCodes}>
                    <Form.Group as={Col} lg="6" md="12">
                        <FormControls.Textarea
                            label="Severity code preferences"
                            name="severityCodePreferences"
                            formHandler={formHandler}
                            rows="2" />
                    </Form.Group> 
                </FormControls.ConditionalRender>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.SelectBox
                        label="Validation tool used"
                        name="validationToolUsedId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        showDefault
                        defaultLabel="Select tool ..."
                        onChange={(e) => {
                            const val = parseInt(e.target.value);
                            formHandler.setFieldValue("validationToolUsedId", val, true)
                        }}
                        options={validationTools}
                    />
                </Form.Group>
                <Form.Group as={Col} lg="6" md="6">
                    <FormControls.SelectBox
                        label="Code Verification Preference"
                        name="codeVerificationPreferenceId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        showDefault
                        defaultLabel="Select preference ..."
                        onChange={(e) => {
                            const val = parseInt(e.target.value);
                            formHandler.setFieldValue("codeVerificationPreferenceId", val, true)
                        }}
                        options={verificationModes}
                    />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col} lg="6" md="12">
                    <FormControls.Textarea
                        label="How to document that chart is on hold"
                        name="chartOnHoldDocumentationMethod"
                        formHandler={formHandler}
                        rows="2" />
                </Form.Group>
                <Form.Group as={Col} lg="6" md="12">
                    <FormControls.Textarea
                        label="How long to keep patient 'waiting on agency'?"
                        name="waitingOnAgencyPreference"
                        formHandler={formHandler}
                        rows="2" />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.DropdownDisplayList
                        label="Return review to"
                        name="returnReviewToId"
                        variant="secondary"
                        formHandler={formHandler}
                        valueField="id"
                        displaySelected={(opt) => getContactInfo(opt?.id)}
                        displayOption={(values) => (<>{values.fullName} <br /> {values.emailAddres}</>)}
                        options={props.contacts} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.SelectBox
                        label="Method of returning review"
                        name="reviewReturnMethodId"
                        numeric
                        formHandler={formHandler}
                        defaultValue={0}
                        showDefault
                        defaultLabel="Select method ..."
                        onChange={(e) => {
                            const val = parseInt(e.target.value);
                            formHandler.setFieldValue("reviewReturnMethodId", val, true)
                        }}
                        options={reviewReturnMethods}
                    />
                </Form.Group>
                <Form.Group as={Col} lg="6" md="12">
                    <FormControls.Textbox
                        label="Message line of email"
                        name="messageLineOfEmail"
                        formHandler={formHandler} />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.DropdownDisplayList
                        label="Referral information contact"
                        name="referralInfoContactId"
                        variant="secondary"
                        formHandler={formHandler}
                        valueField="id"
                        displaySelected={(opt) => getContactInfo(opt?.id)}
                        displayOption={(values) => (<>{values.fullName} <br /> {values.emailAddres}</>)}
                        options={props.contacts} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.DropdownDisplayList
                        label="Coding clarification contact"
                        name="codingClarificationContactId"
                        variant="secondary"
                        formHandler={formHandler}
                        valueField="id"
                        displaySelected={(opt) => getContactInfo(opt?.id)}
                        displayOption={(values) => (<>{values.fullName} <br /> {values.emailAddres}</>)}
                        options={props.contacts} />
                </Form.Group>
                <Form.Group as={Col} lg="3" md="6">
                    <FormControls.DropdownDisplayList
                        label="Oasis answers clarification contact"
                        name="oasisAnswerClarificationContactId"
                        variant="secondary"
                        formHandler={formHandler}
                        valueField="id"
                        displaySelected={(opt) => getContactInfo(opt?.id)}
                        displayOption={(values) => (<>{values.fullName} <br /> {values.emailAddres}</>)}
                        options={props.contacts} />
                </Form.Group>
            </Form.Row>
        </>
    );
}

export default CustomerCodingProfile;